import { ApiClient, ApiModelPortfolioUsage } from '@/api'
import { Space, Typography } from '@/components/core-v2'
import { CheckboxAccordion } from '@/components/core-v2/molecules'
import { getComparisonDatasets } from '@/components/core-v2/organisms/portfolio-restrictions/utilities'

import { StyledVerticalDivider } from './styled-vertical-divider'

export interface RestrictionsData {
  allowedBusinessUnitIds: string[]
  clients: ApiClient[]
  usage: ApiModelPortfolioUsage
}

export const ProposedChangesModalRestrictions = ({
  currentData,
  proposedData
}: {
  currentData: RestrictionsData
  proposedData: RestrictionsData
}) => {
  const { originalData, proposedData: proposedDataNew } = getComparisonDatasets(
    currentData.clients,
    proposedData.clients,
    currentData.usage,
    proposedData.usage,
    currentData.allowedBusinessUnitIds,
    proposedData.allowedBusinessUnitIds
  )

  return (
    <Space isflex flexGrow={1}>
      <Space
        alignItems="center"
        data-testid="current-permissions"
        flexBasis="50%"
        flexDirection="column"
        mr={3}
      >
        <Space mb={6}>
          <Typography fontSize="15px" fontWeight="bold" textAlign="center" variant="b3">
            Current
          </Typography>
        </Space>
        <CheckboxAccordion isReadOnly data={originalData} />
      </Space>
      <StyledVerticalDivider />
      <Space
        alignItems="center"
        data-testid="proposed-permissions"
        flexBasis="50%"
        flexDirection="column"
        ml={3}
      >
        <Space mb={6}>
          <Typography fontSize="15px" fontWeight="bold" textAlign="center" variant="b3">
            Proposed changes
          </Typography>
        </Space>
        <CheckboxAccordion isReadOnly data={proposedDataNew} />
      </Space>
    </Space>
  )
}
